module.exports = __webpack_public_path__ + "img/Scutum.59c983a0.png";